import { FormInstance } from 'antd'
import { TFunction } from 'next-i18next'
import { AppDispatch } from 'src/app/store'
import { showNotification } from 'src/core/helpers'
import { resetValidateEmailForStockSaleState, resetValidateProjectIdForStockSale } from 'src/features'
import BrokerageCertificateLanguage from './BrokerageCertificateLanguage/BrokerageCertificateLanguage'
import BrokerageCreatedAtField from './BrokerageCreatedAtField/BrokerageCreatedAtField'
import BrokerageInvoiceDocumentField from './BrokerageInvoiceDocumentField/BrokerageInvoiceDocumentField'
import BrokerageInvoiceNumberField from './BrokerageInvoiceNumberField/BrokerageInvoiceNumberField'
import BrokerageOffsetReasonField from './BrokerageOffsetReasonField/BrokerageOffsetReasonField'
import BrokeragePresentedToField from './BrokeragePresentedToField/BrokeragePresentedToField'
import BrokerageProjectIdField from './BrokerageProjectIdField/BrokerageProjectIdField'
import BrokerageSalePriceField from './BrokerageSalePriceField/BrokerageSalePriceField'
import BrokerageSellerUserField from './BrokerageSellerUserField'
import BrokerageStockField from './BrokerageStockField/BrokerageStockField'



export const brokerageFields = {
  BrokerageCertificateLanguage,
  BrokerageCreatedAtField,
  BrokeragePresentedToField,
  BrokerageSalePriceField,
  BrokerageStockField,
  BrokerageProjectIdField,
  BrokerageSellerUserField,
  BrokerageOffsetReasonField,
  BrokerageInvoiceNumberField,
  BrokerageInvoiceDocumentField
}

export const resetBrokerageForm = (
  dispatch: AppDispatch, setNewLink: Function,
  form: FormInstance, showResetMessage: boolean, t: TFunction,
  setCurrentOffsetReason: Function, setOnResetFile
) => {
  dispatch(resetValidateProjectIdForStockSale())
  dispatch(resetValidateEmailForStockSaleState())
  setNewLink(null)
  setCurrentOffsetReason(null)
  setOnResetFile(true)
  form.resetFields()
  form.setFieldsValue({ certificateLanguage: 'en' })
  if (showResetMessage) {
    showNotification('info', t('admin.Brokerage.ResetForm'))
  }
}
